/**
 * Every validation failure in the core carries the exact user-facing wording
 * from SPECIFICATION.md clause 16, so the copy deck lives at its source rather
 * than being re-invented in the UI layer.
 */
export class BrickwallError extends Error {
  override readonly name = 'BrickwallError';
}

export function fail(message: string): never {
  throw new BrickwallError(message);
}
